import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { ApplicationSubmodule } from './application-submodules.types';

export const APPLICATION_SUBMODULES_API_URL = new InjectionToken<string>('Application submodules api url');

@Injectable()
export class ApplicationSubmodulesApiService {
  readonly #http = inject(HttpClient);
  readonly #url = inject(APPLICATION_SUBMODULES_API_URL);

  get(moduleId: string, personId: string, optionalParams?: { device?: string | null }): Observable<ApplicationSubmodule[]> {
    let params = new HttpParams({ fromObject: { moduleId, personId } });

    if (optionalParams) {
      if (optionalParams.device) {
        params = params.set('device', optionalParams.device);
      }
    }

    return this.#http.get<ApplicationSubmodule[]>(this.#url, { params });
  }
}
